import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    viaticos: [],
    /* Info de paginación */
    paginaActual: 1,
    totalPaginas: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).add(60, 'days').format('YYYY-MM-DD'),
    personal: null
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.viaticos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-60, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).add(60, 'days').format('YYYY-MM-DD');
        state.personal = null;
    },

    'INICIALIZAR' (state) {
        state.viaticos = [];
    },
    'SET_VIATICOS' (state, viaticos) {
        state.viaticos = viaticos;
    },
    'SET_PAGINATION' (state, params) {
        state.paginaActual = params.paginaActual;
        state.totalPaginas = params.totalPaginas;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getViaticos: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR');

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
          
            if (state.personal) {
                if (state.personal != null) {
                    if (state.personal.id != 0) {
                        queryString += '&personalId=' + state.personal.id;
                    }
                }
            }
    
            apiAxios.get('viaticos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params= {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages
                        }
                        commit ('SET_PAGINATION', params);
                    }

                    commit ('SET_VIATICOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    autorizar ( {}, params ) {
        return new Promise((resolve, reject) => {
            let viaticoAutorizacion = {
                autorizado: params.autorizado,
                observaciones: params.observaciones.trim()
            }

            apiAxios.post('viaticos/' + params.viaticoId + '/autorizar', viaticoAutorizacion) 
                .then( () => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( {}, viaticoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('viaticos/' + viaticoId + '/delete' ) 
                .then( () => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deletePago ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('viaticos/' + params.viaticoId + '/pago/' + params.viaticoPagoId + '/delete' ) 
                .then( () => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}